"use client";

import { ConvexReactClient, ConvexProviderWithAuth } from "convex/react";
import { ReactNode, useMemo } from "react";

const convex = new ConvexReactClient(process.env.NEXT_PUBLIC_CONVEX_URL!);

// The inherited tmuafyi surfaces render under this provider. Their Stytch auth
// has been removed (Wonder runs its own Convex Auth under app/wonder), so this
// resolves to a permanently signed-out session: legacy authed reads return no
// user, the same state the placeholder Stytch token already produced. It stays
// a ConvexProviderWithAuth (not a plain ConvexProvider) because root children
// such as AutumnClientProvider call useConvexAuth().
function useNoAuth() {
  return useMemo(
    () => ({
      isLoading: false,
      isAuthenticated: false,
      fetchAccessToken: async () => null,
    }),
    [],
  );
}

export default function ConvexClientProvider({
  children,
}: {
  // Still passed by app/layout.tsx but no longer used: Stytch keyed its JWT
  // template off the board, and Stytch is gone. Kept so the call site compiles;
  // drop it together with the layout.tsx prop in a follow-up.
  boardId?: string;
  children: ReactNode;
}) {
  return (
    <ConvexProviderWithAuth client={convex} useAuth={useNoAuth}>
      {children}
    </ConvexProviderWithAuth>
  );
}
